import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { SUPPORTED_COUNTRIES } from "@faire/web-api--source/indigofair/settings/SUPPORTED_COUNTRIES";

type ISupportedCountries = Exclude<
  keyof typeof ISO3166Alpha3,
  "ISO3166ALPHA3_UNKNOWN"
>;

const defaultValue: ISupportedCountries[] = ["USA", "CAN", "GBR"];

export const getSettingSupportedCountries = (): ISupportedCountries[] =>
  getSettingValueWithoutAssignment(
    SUPPORTED_COUNTRIES,
    defaultValue
  ) as ISupportedCountries[];

export const isSupportedCountry = (iso3166Alpha3: string): boolean =>
  !!iso3166Alpha3 &&
  getSettingSupportedCountries().includes(iso3166Alpha3 as ISupportedCountries);
